<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div class="row">
    <div class="col-10 d-flex" style="color: #044169; margin-top: -4px; font-weight: 600; width: 90%">
      <em class="calculad" style="width: 2%"></em>
      <span class="textSize ml-2" style="font-weight: 600;margin-top: 5px;">Calculadora de métodos de pago</span>
    </div>
    <div class="col-2 text-right">
      <em class="close_equis_svg" style="width: 12%; cursor: pointer" @click="hideModal()"/>
    </div>
    </div>
    <br/>

    <div class="d-flex">
      <div class="d-flex justify-content-center align-items-center" style="padding-left: 3%; padding-right: 2%; height: 2.5em"
           @click="activeTab = index"
           :class="activeTab === index ? 'tabsTdc seleccionado' : 'tabsTdc'"
           v-for="(opt, index) in tabs" :key="index" :title="opt.nombre">
        <p class="mt-3" style="font-size: 12px">
          {{ opt.label }}
        </p>
        <div v-if="activeTab === index" :class="activeTab === index ? 'tabsTdcUnderline seleccionado' : 'tabsTdc'" style="position: absolute">
        </div>
      </div>
    </div>








        <TarjetaDeCreditoPF v-if="activeTab === 0"
                            :totalInversion="totalInversion"
                            :idPaciente="idPaciente"
        />

        <SinTdcPF v-if="activeTab === 1"
                  :totalInversion="totalInversion"
                  :idPaciente="idPaciente"
        />

        <HerramientaCierrePF v-if="activeTab === 2"
                             :totalInversion="totalInversion"
                             :tratamientosInversion="tratamientosInversion"
                             :idPaciente="idPaciente"
        />




  </div>
</template>
<script>
import TarjetaDeCreditoPF from "@/version5/negociacion/Calculadora/TarjetaDeCreditoPF.vue";
import SinTdcPF from "@/version5/negociacion/Calculadora/SinTdcPF.vue";
import HerramientaCierrePF from "@/version5/negociacion/Calculadora/HerramientaCierrePF.vue";

export default {
  name: "CalculadoraPF",
  components: {HerramientaCierrePF, SinTdcPF, TarjetaDeCreditoPF},
  props: {
    totalInversion: Number,
    tratamientosInversion: Array,
    idPaciente: Number
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    activeTab: 0,
    tabs: [
      {name: 'Tab 1', label: 'Tarjeta de Crédito'},
      {name: 'Tab 2', label: 'Sin Tarjeta de crédito'},
      {name: 'Tab 3', label: 'Herramienta de Cierre'}
    ],
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    hideModal(){
      this.$emit("hideModal");
    }
  }
}
</script>
<style scoped>
.textSize {
  font-size: 0.8em;
}
.tabsTdc.seleccionado {
  color: #0069A9;
}
.tabsTdcUnderline.seleccionado {
  color: red;
  height: 2px;
  width: 14%;
  background: #0069A9;
  margin-top: 25px;
}

.tabsTdc:hover {
  font-weight: 600;
}


.tabs {
  display: flex;
  cursor: pointer;
  margin-bottom: 10px;
}

.tab {
  padding: 10px 20px;
  border: 1px solid transparent;
}

.tab.active {
  border-bottom: 2px solid blue; /* Línea de tab activo */
  font-weight: bold; /* Puedes agregar más estilos aquí */
}

.content {
  padding: 10px;
}


</style>